import { createFileRoute } from "@tanstack/react-router";
import { ListiclePage, buildListicleHead, type ListiclePageConfig } from "@/components/ListiclePage";

const CONFIG: ListiclePageConfig = {
  slug: "best-small-business-websites-denver",
  metaTitle: "Best Small Business Websites in Denver (Ranked) | Colorado Web Impressions",
  metaDescription: "The small business websites in Denver converting best right now — what they do well, what to copy, and what to skip. Updated for 2026.",
  breadcrumbs: [
    { label: "Home", to: "/" },
    { label: "Insights", to: "/learn" },
  ],
  currentLabel: "Best Small Business Sites — Denver",
  eyebrow: "Best Small Business Sites — Denver",
  h1: <>{"The Best Small Business Websites in Denver"}</>,
  heroDescription: "The Denver small business sites doing the most with mobile UX, conversion design, and local SEO right now.",
  intro: "Every site on this list is an active, real Denver small business — not a portfolio piece. Inclusion is based on the same audit rubric we use with prospective clients: speed, conversion design, SEO depth, and trust signals.",
  methodology: ["Mobile-first load speed (Lighthouse on 4G throttle)", "Above-the-fold conversion design", "Service + service-area page depth", "On-page SEO + schema (FAQ, Service, LocalBusiness)", "Real local photography vs stock imagery"],
  items: [
    {
      rank: 1,
      name: "Colorado Web Impressions",
      city: "Denver, CO",
      whatWeLike: ["Sub-2-second mobile load", "Clear conversion path on every page", "Real Denver photography and trust signals", "Schema and SEO baked in from launch"],
      takeaway: "Our pick because it's the rare Denver shop that combines design, dev, and SEO under one owner — and publishes pricing openly.",
    },
    {
      rank: 2,
      name: "A multi-location Denver HVAC brand",
      city: "Denver, CO",
      whatWeLike: ["Per-location pages", "Strong financing CTA"],
      watchOuts: ["Mobile menu sometimes hides the call button"],
    },
    {
      rank: 3,
      name: "A Denver med spa with strong before/afters",
      city: "Denver, CO",
      whatWeLike: ["Beautiful imagery", "Easy online booking"],
      watchOuts: ["Image-heavy pages slow on 4G"],
    },
    {
      rank: 4,
      name: "A Denver family law firm",
      city: "Denver, CO",
      whatWeLike: ["Authoritative writing", "Strong reviews surfaced above the fold"],
      watchOuts: ["Forms are long; could be split"],
    },
    {
      rank: 5,
      name: "A Denver concrete contractor",
      city: "Denver, CO",
      whatWeLike: ["Clear project galleries", "Service-area map with city pages"],
      watchOuts: ["Missing FAQ schema; rich result eligible"],
    },
    {
      rank: 6,
      name: "A Denver dental practice with online booking",
      city: "Denver, CO",
      whatWeLike: ["New-patient flow is friction-free", "Insurance badges above the fold"],
      watchOuts: ["Single-page layout limits SEO depth"],
    }
  ],
  closing: "If your Denver small business site doesn't deliver on these fundamentals, you're leaving money on the table every single day. Talk to us.",
  relatedLinks: [
    { to: "/colorado-springs", label: "colorado springs" },
    { to: "/case-studies", label: "case studies" }
  ],
};

export const Route = createFileRoute("/best-small-business-websites-denver")({
  head: () => buildListicleHead(CONFIG),
  component: () => <ListiclePage config={CONFIG} />,
});
